import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { InputGroup, FormControl, DropdownButton, Dropdown, Form } from 'react-bootstrap';
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';

import { paginate } from '../utils/paginate';
import Pagination from './common/pagination';
import TextareaAutosize from 'react-textarea-autosize';
import { formatDistanceToNowStrict } from 'date-fns';
import ar from 'date-fns/locale/ar-SA';

import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { ListGroup, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';




const based_url = 'https://gptdream.whatsbot.world/api/';
const GPTDreams = () => {
    const [data, setData] = useState([]);
    const [smsData, setSmsData] = useState([]);
    const [sentData, setSentData] = useState([]);
    const [mobileData, setMobileData] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    const [readyToSendData, setReadyToSendData] = useState([]);
    const [replyMsg1, setReplyMsg1] = useState('');
    const [replyMsg2, setReplyMsg2] = useState('');
    const [filter, setFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    //const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [fromDate, setFromDate] = useState('');
    const [paginatedata, setPaginateData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [counts, setCounts] = useState({});
    const [mobile, setMobile] = useState('');
    const [searchData, setsearchData] = useState([]);
    const [selected, setSelected] = useState('smsData');
    const [oldData, setOldData] = useState([]);
    const [filterType, setFilterType] = useState('all');
    const pageSize = 25;

    const selectData = () => {
        switch (selected) {
            case 'sentData':
                return sentData;
            case 'smsData':
                return smsData;
            case 'deleteData':
                return deleteData;
            case 'readyToSendData':
                return readyToSendData;
            case 'mobileData':
                return mobileData;
            default:
                return smsData;
        }
    };


    useEffect(() => {

        setData(paginate(selectData(), 0, pageSize));

        // Do whatever you need to do when selected changes
    }, [selected]); // Re-run this effect whenever `selected` changes

    useEffect(() => {



        // Do whatever you need to do when selected changes
    }, [data]);
  
    const fetchData_Mobile = async () => {
        if (mobile !== "") {
            let url = `${based_url}messages-sent/?mobile=${mobile}`;

            const res = await axios.get(url , {
            headers: {
                'Token': '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'
            }
        });
            setMobileData(res.data.results);
            setSelected("mobileData")
        } else {
            setSelected("smsData")
        }

    };

   



    const fetchByType_first = async (type, stateSetFunction, filter, currentState) => {
        
        let url = `${based_url}${type}?${filter}`;

        const res = await axios.get(url, {
            headers: {
                'Token': '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'
            }
        });

        stateSetFunction(res.data.results)
        if (type ==="messages-reply"){
            setData(res.data.results)
        }
    };

    const fetchByType = async (type, stateSetFunction, filter, currentState) => {
        const currentDate = new Date();
        const oneDayAgo = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);

        let formattedStartDate = `${oneDayAgo.getFullYear()}-${String(oneDayAgo.getMonth() + 1).padStart(2, '0')}-${String(oneDayAgo.getDate()).padStart(2, '0')}`;
        let formattedEndDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;

        let url = `${based_url}date-range-messages?start_date=${formattedStartDate}&end_date=${formattedEndDate}&${filter}`;

        const res = await axios.get(url , {
            headers: {
                'Token': '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'
                }
        });

        const newEntries = res.data.results.filter(
            (result) => !currentState.some((entry) => entry.id === result.id)
        );

        stateSetFunction((oldData) => [...oldData, ...newEntries]);
    };

    const fetchData_reply_first = async () => {
        fetchByType_first('messages-reply', setSmsData, 'isreply=true&isreadytosend=false&issent=false&isdelete=false', smsData);
    };

    const fetchData_delete_first = async () => {
        fetchByType_first('messages-delete', setDeleteData, 'isdelete=true', deleteData);
    };

    const fetchData_sent_first = async () => {
        fetchByType_first('messages-sent', setSentData, 'isreply=true&isreadytosend=true&issent=true&isdelete=false', sentData);
    };

    const fetchData_ready_to_send_first = async () => {
        fetchByType_first('messages-ready-to-send', setReadyToSendData, 'isreply=true&isreadytosend=true&issent=false&isdelete=false', readyToSendData);
    };




    const fetchData_reply = async () => {
        fetchByType('reply', setSmsData, 'isreply=true&isreadytosend=false&issent=false&isdelete=false', smsData);
    };

    const fetchData_delete = async () => {
        fetchByType('deleteData', setDeleteData, 'isdelete=true', deleteData);
    };

    const fetchData_sent = async () => {
        fetchByType('sent', setSentData, 'isreply=true&isreadytosend=true&issent=true&isdelete=false', sentData);
    };

    const fetchData_ready_to_send = async () => {
        fetchByType('readyToSend', setReadyToSendData, 'isreply=true&isreadytosend=true&issent=false&isdelete=false', readyToSendData);
    };

    const put_reply_in_data=()=>{
        setData(smsData)
    }


    useEffect(() => {
        // Fetch data initially
        fetchData_reply_first();
        fetchData_delete_first();
        fetchData_sent_first();
        fetchData_ready_to_send_first();

        // Set intervals to fetch data
        const interval_reply = setInterval(fetchData_reply, 180000);  // every 3 minutes
        const interval_delete = setInterval(fetchData_delete, 180000);  // every 3 minutes
        const interval_sent = setInterval(fetchData_sent, 180000);  // every 3 minutes
        const interval_ready_to_send = setInterval(fetchData_ready_to_send, 60000);  // every 1 minute

        // Cleanup function clears the intervals when the component unmounts
        return () => {
            clearInterval(interval_reply);
            clearInterval(interval_delete);
            clearInterval(interval_sent);
            clearInterval(interval_ready_to_send);
        };
    }, []);

    const handleReplyMsg1Change = (e) => {
        setReplyMsg1(e.target.value);
    };

    const handleReplyMsg2Change = (e) => {
        setReplyMsg2(e.target.value);
    };


    const handleMOMsgChange = (smsId, event) => {
        // Get the new value from event.target.value
        const newMOmsg = event.target.value;

        // Create a new data array with the updated message
        const newData = data.map((message) => {
            if (message.id === smsId) {
                // Update the momsg field of the message that we want to change
                return { ...message, momsg: newMOmsg };
            } else {
                // Leave all other messages unchanged
                return message;
            }
        });

        // Update the state with the new data array
        setData(newData);
    };

    const handleMTMsg1Change = (smsId, event) => {
        // Get the new value from event.target.value
        const newMTMsg1 = event.target.value;

        // Create a new data array with the updated message
        const newData = data.map((message) => {
            if (message.id === smsId) {
                // Update the mtmsg1 field of the message that we want to change
                return { ...message, mtmsg1: newMTMsg1 };
            } else {
                // Leave all other messages unchanged
                return message;
            }
        });

        // Update the state with the new data array
        setData(newData);
    };

    const handleMTMsg2Change = (smsId, event) => {
        // Get the new value from event.target.value
        const newMTMsg2 = event.target.value;

        // Create a new data array with the updated message
        const newData = data.map((message) => {
            if (message.id === smsId) {
                // Update the mtmsg1 field of the message that we want to change
                return { ...message, mtmsg2: newMTMsg2 };
            } else {
                // Leave all other messages unchanged
                return message;
            }
        });

        // Update the state with the new data array
        setData(newData);
    };


    const handleMOSMSSend = async (smsId) => {
        try {
            // Find the sms in the data state
            const sms = data.find(sms => sms.id === smsId);

            // Get the momsg value from the sms
            const momsg = sms.momsg;

            const response = await axios.put(`/api/smssc/${smsId}/`, {
                momsg,
            }, {
                headers: {
                    'Token': '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'
                }
            });

            console.log('Reply Msg 2 sent:', response.data);

            // Update local state
            let dataIndex = data.findIndex(sms => sms.id === smsId); // find index of the updated element
            let newData = [...data]; // create a copy of the data array
            newData[dataIndex] = response.data; // replace the element with updated data from the server
            setData(newData); // update the state

        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleReplyMsg1Send = async (smsId) => {
        try {
            const sms = data.find(sms => sms.id === smsId);

            // Get the momsg value from the sms
            const mtmsg1 = sms.mtmsg1;
            const response = await axios.put(`/api/smssc/${smsId}/`, {
                mtmsg1,
                isreadytosend: true,
                sentmtmsg: mtmsg1,
                sentdate: new Date()
            }, {
                headers: {
                    'Token': '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'
                }
            });

            console.log('Reply Msg 1 sent:', response.data);

            // Update local state
            let dataIndex = data.findIndex(sms => sms.id === smsId); // find index of the updated element
            let newData = [...data]; // create a copy of the data array
            newData[dataIndex] = response.data; // replace the element with updated data from the server
            setData(newData); // update the state

        } catch (error) {
            console.error('Error:', error);
        }
    };
    const handleReplyMsg2Send = async (smsId) => {
        try {
            const sms = data.find(sms => sms.id === smsId);

            // Get the momsg value from the sms
            const mtmsg2 = sms.mtmsg2;
            const response = await axios.put(`/api/smssc/${smsId}/`, {
                mtmsg2,
                isreadytosend: true,
                sentmtmsg: mtmsg2,
                sentdate: new Date()
            }, {
                headers: {
                    'Token': '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'
                }
            });

            console.log('Reply Msg 2 sent:', response.data);

            // Update local state
            let dataIndex = data.findIndex(sms => sms.id === smsId); // find index of the updated element
            let newData = [...data]; // create a copy of the data array
            newData[dataIndex] = response.data; // replace the element with updated data from the server
            setData(newData); // update the state

        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleDelete = async (smsId) => {
        try {
            const response = await axios.put(`/api/smssc/${smsId}/`, {
                isdelete: true,
            }, {
                headers: {
                    'Token': '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'
                }
            });

            console.log('SMS entry deleted:', response.data);

            // Update the state with the new data.
            setData(data.map(item => item.id === smsId ? response.data : item));

        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };




    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const setFilterAndResetPage = (filter) => {
        setFilterType(filter);
        setCurrentPage(0);
    }

    const filterMessages = (data, filter) => {
        let now = new Date();
        switch (filter) {
            case 'اليوم':
                return data.filter(msg => formatDistanceToNowStrict(new Date(msg.modate), { locale: ar }) === "أقل من دقيقة");
            case 'الأمس':
                return data.filter(msg => formatDistanceToNowStrict(new Date(msg.modate), { locale: ar }) === "1 يوم");
            case 'هذا الأسبوع':
                let weekStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay());
                return data.filter(msg => new Date(msg.modate) >= weekStart);
            case 'هذا الشهر':
                let monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                return data.filter(msg => new Date(msg.modate) >= monthStart);
            case 'قديم':
                let oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
                return data.filter(msg => new Date(msg.modate) < oneMonthAgo);
            default:
                return data;
        }
    }

    const filteredMessages = filterMessages(data, filterType);
    const messagesToRender = paginate(filteredMessages, currentPage, pageSize);
    const totalCount = filteredMessages.length;
    return (
        <React.Fragment>
        <div className="row">
                <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right   flex-nowrap">
             

                <Grid container spacing={3} style={{ marginTop: '1em' }}>
                    {Object.entries(counts).map(([metric, counts]) => (
                        <Grid item xs={12} md={6} lg={3} key={metric}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography color="textSecondary" variant="h5">{metric}</Typography>
                                    {Object.entries(counts).map(([period, count]) => (
                                        <Typography key={period} variant="body1">{`${period.charAt(0).toUpperCase() + period.slice(1)}: ${count}`}</Typography>
                                    ))}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
           
</div>
                <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right   flex-nowrap">
           <div dir='rtl'>
                        <ButtonToolbar aria-label="Toolbar with button groups"  >
                            <ButtonGroup className="mr-2" aria-label="First group">
                                <Button variant="primary" onClick={() => setFilterAndResetPage('all')}>الكل</Button>
                                <Button variant="secondary" onClick={() => setFilterAndResetPage('اليوم')}>اليوم</Button>
                                <Button variant="success" onClick={() => setFilterAndResetPage('الأمس')}>الأمس</Button>
                                <Button variant="warning" onClick={() => setFilterAndResetPage('هذا الأسبوع')}>هذا الأسبوع</Button>
                                <Button variant="danger" onClick={() => setFilterAndResetPage('هذا الشهر')}>هذا الشهر</Button>
                                <Button variant="dark" onClick={() => setFilterAndResetPage('قديم')}>قديم</Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                        <hr></hr>
                        <input type="text" value={mobile} onChange={fetchData_Mobile} placeholder="رقم الموبايل كامل" />
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button
                                    variant={selected === 'smsData' ? 'primary' : 'secondary'}
                                    onClick={() => setSelected('smsData')}
                                >
                                    تدقيق للارسال
                                </Button>
                                <Button
                                    variant={selected === 'mobileData' ? 'primary' : 'secondary'}
                                    onClick={() => setSelected('mobileData')}
                                >
                                    كل أحلام رقم الموبايل
                                </Button>
                                <Button
                                    variant={selected === 'readyToSendData' ? 'primary' : 'secondary'}
                                    onClick={() => setSelected('readyToSendData')}
                                >
                                    جاهز للارسال
                                </Button>
                                <Button
                                    variant={selected === 'sentData' ? 'primary' : 'secondary'}
                                    onClick={() => setSelected('sentData')}
                                >
                                    تم الإرسال
                                </Button>
                                <Button
                                    variant={selected === 'deleteData' ? 'primary' : 'secondary'}
                                    onClick={() => setSelected('deleteData')}
                                >
                                    محذوف
                                </Button>
                                <Button variant="primary" type="submit">Filter</Button>
                            </ButtonGroup>
                        </ButtonToolbar>
           </div>

                  
</div>
</div>
            <div className="row flex-nowrap" dir='rtl'>
        <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right flex-nowrap">

                <hr></hr>
                <br>
                </br>
                <Pagination
                    itemsCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
                <table className="table text-right">
                    <thead>
                        <tr>
                                <th className="col1">معلومات</th>
                          
                                <th className="col2">الحلم</th>
                           
                                <th className="col3">رد GPT </th>
                           
                                <th className="col4">حذف</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((sms) => (
                            <tr key={sms.id}>

                                <td className="col1">{sms.shortcode} <hr style={{ borderTop: "1px solid blue" }} />
                                   {sms.mobile}
                                    <hr style={{ borderTop: "1px solid blue" }} />
                                 {sms.modate ?
                                    <div>
                                        <span>{"استقبال :"}</span>
                                        <span>{new Date(sms.modate).toLocaleString('ar-EG')}</span>
                                    </div>
                                    :
                                    null
                                }
                                    <hr style={{ borderTop: "1px solid blue" }} />
                                    {sms.sentdate ?
                                        <div>
                                            <span>{"ارسال :"}</span>
                                            <span>{new Date(sms.sentdate).toLocaleString('ar-EG')}</span>
                                        </div>
                                        :
                                        null
                                    }
                                </td>
                                <td className="col2"> <TextareaAutosize
                                 
                                    className="form-control"
                                    style={{ direction: "rtl" }}
                                    rows={4}
                                    value={sms.momsg}
                                    onChange={(event) => handleMOMsgChange(sms.id, event)}
                                />
                                <br></br>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => handleMOSMSSend(sms.id)}
                                    >
                                        حفظ واعادة التفسير
                                    </button>

                                </td>
                              
                                <td className="col3">
                                    {sms.mtmsg1orginal}
                                    <hr></hr>
                                    {sms.mtmsg1 &&
                                    <TextareaAutosize
                                        className="form-control"
                                        style={{ direction: "rtl" }}
                                        rows={4}
                                        value={sms.mtmsg1}
                                        onChange={handleMTMsg1Change}
                                        />}
                                    <br></br>
                                    {sms.mtmsg1 && sms.mtmsg1 !== '' ? (
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => handleReplyMsg1Send(sms.id)}
                                        >
                                            ارسال
                                        </button>
                                    ) : null}
                                   
                                  
                            <hr></hr>

                                    {sms.mtmsg2orginal && <h5>الرد الثاني</h5>}
                                    {sms.mtmsg2orginal && sms.mtmsg2orginal}
                                    {sms.mtmsg2orginal && <div>
                                    <hr></hr>
                                    {sms.mtmsg2 &&
                                    <TextareaAutosize
                                        className="form-control"
                                        value={sms.mtmsg2 ? sms.mtmsg2:""}
                                        onChange={handleReplyMsg2Change}
                                    />}
                                    <br></br>
                                    {sms.mtmsg2 && sms.mtmsg2 !== '' ? (
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => handleReplyMsg2Send(sms.id)}
                                        >
                                            ارسال
                                        </button>
                                        ) : null}</div>}
                                    
                                </td>

                                <td className="col4">
                                    <button className="btn btn-danger" onClick={() => handleDelete(sms.id)}>
                                        حذف
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div>
                    <Pagination
                        itemsCount={totalCount}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                </div>
                </div>     </div>
      </React.Fragment>
    );
};

export default GPTDreams;


// WEBPACK FOOTER //
// ./src/components/gptdreams.jsx